import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { API_URL } from './constants'
import axios from 'axios'

Vue.config.productionTip = false

window.axios = axios.create({
	baseURL: API_URL
})

const eventBus = new Vue()
Vue.prototype.$eventBus = eventBus

window.axios.defaults.headers.common['accept-language'] = 'ar'

window.axios.interceptors.response.use(
	function (response) {
		return response
	},

	function (error) {
		console.log(error, 'error')
		if (!window.navigator.onLine) {
			eventBus.$emit('error', true)
			return Promise.reject(error)
		}
		if (error.response) {
			if (error.response.status === 401) {
				store.dispatch('auth/logout')
				eventBus.$emit('show-snackbar', true, 'تم تعديل معلومات الحساب')
				if (router.history.current.name !== 'login') router.replace({ name: 'login' })
			} else if (error.response.status === 405) {
				return Promise.reject(error)
			} else {
				eventBus.$emit('error', false)
			}
		} else if (
			error.code === 'ERR_NETWORK' ||
			error.code === 'ETIMEDOUT' ||
			error.code === 'ECONNABORTED'
		) {
			eventBus.$emit('error', true)
		}
		return Promise.reject(error)
	}
)

if (!localStorage.getItem('auth')) {
	router.replace({ name: 'login' })
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
